import React from 'react';
import classNames from 'classnames';
import { defineMessages, useIntl } from 'react-intl';
import styles from './index.scss';
import type { BillingPlan } from '../types';

const messages = defineMessages({
  leftPlanLabel: {
    id: 'pricing.leftPlanLabel',
    description: 'Accessible label for the left plan picker on mobile pricing',
    defaultMessage: 'Left plan',
  },
  rightPlanLabel: {
    id: 'pricing.rightPlanLabel',
    description: 'Accessible label for the right plan picker on mobile pricing',
    defaultMessage: 'Right plan',
  },
});

interface PricingPlanPickerProps {
  plans: BillingPlan[];
  selectedPlanIndex: number;
  onPlanChange: (planIndex: number) => void;
  pickerId: string;
  ariaLabel: string;
}

const PricingPlanPicker: React.FC<PricingPlanPickerProps> = ({
  plans,
  selectedPlanIndex,
  onPlanChange,
  pickerId,
  ariaLabel,
}) => (
  <select
    id={pickerId}
    className={styles.planPickerSelect}
    value={selectedPlanIndex}
    aria-label={ariaLabel}
    onChange={(event) => onPlanChange(Number(event.target.value))}
  >
    {plans.map((plan, index) => (
      <option key={plan.plan_id} value={index}>
        {plan.tier}
      </option>
    ))}
  </select>
);

export interface PricingPlanPickersProps {
  plans: BillingPlan[];
  leftPlanIndex: number;
  rightPlanIndex: number;
  onLeftPlanChange: (planIndex: number) => void;
  onRightPlanChange: (planIndex: number) => void;
}

export const PricingPlanPickers: React.FC<PricingPlanPickersProps> = ({
  plans,
  leftPlanIndex,
  rightPlanIndex,
  onLeftPlanChange,
  onRightPlanChange,
}) => {
  const intl = useIntl();

  return (
    <>
      <div className={styles.planPickerCell}>
        <PricingPlanPicker
          plans={plans}
          selectedPlanIndex={leftPlanIndex}
          onPlanChange={onLeftPlanChange}
          pickerId="pricing-plan-picker-left"
          ariaLabel={intl.formatMessage(messages.leftPlanLabel)}
        />
      </div>
      <div
        className={classNames(
          styles.planPickerCell,
          styles.planPickerCellRight,
        )}
      >
        <PricingPlanPicker
          plans={plans}
          selectedPlanIndex={rightPlanIndex}
          onPlanChange={onRightPlanChange}
          pickerId="pricing-plan-picker-right"
          ariaLabel={intl.formatMessage(messages.rightPlanLabel)}
        />
      </div>
    </>
  );
};

export default PricingPlanPicker;
